import { createModalHook } from '@change-corgi/design-system-legacy/modals';

import { FeedbackBody } from '../../components/FeedbackBody';
import type { Recommendation } from '../useShareRecommendations';

export type ModalOptions = {
	recommendationGroup: string;
	recommendation: Recommendation;
};

export type ModalResult = {
	submitted?: boolean;
};

export const useFeedbackModal = createModalHook<ModalOptions, ModalResult>({
	closeButton: true,
	name: 'SharingRecommendationsFeedbackModal',
	body: function ModalBody({ options, closeModal }) {
		return <FeedbackBody onClose={closeModal} options={options} />;
	},
});
